import * as React from 'react';
import { AppRoute, getRoute, RoutePath } from 'modules/navigation';
import { Link } from 'react-router-dom';

interface Props {
  loginRoute: AppRoute;
}

export const ErrorPermissions: React.FC<Props> = ({
  loginRoute = getRoute(RoutePath.Login)
}) => (
  <section className="v-errorpage">
    <div className="v-errorpage__content">
      <div className="card">
        <h1 className="t-gamma s-bottom--lrg">
          Nemate dozvolu za pristup ovoj stranici.
        </h1>
        <p className="t-zeta s-bottom--lrg">
          Prijavite se za pristup željenoj stranici.
        </p>
        <Link to={loginRoute.path} className="btn btn--primary btn--med">
          {loginRoute.title}
        </Link>
      </div>
    </div>
  </section>
);
